import api from '../BaseUrl';

export interface Admin {
  id: number;
  userName: string;
  email: string;
  /** only sent when creating, or when changing it in an update */
  password?: string | null;
}

export const getAdmins = async (): Promise<Admin[]> => {
  const res = await api.get<Admin[]>('/api/Admin/GetAllAdmin');
  return res.data;
};

export const createAdmin = async (admin: Omit<Admin, 'id'>): Promise<void> => {
  await api.post('/api/Admin/CreateAdmin', admin);
};

/** An empty password keeps the current one. */
export const updateAdmin = async (id: number, admin: Omit<Admin, 'id'>): Promise<void> => {
  await api.put(`/api/Admin/UpdateAdmin/${id}`, admin);
};

export const deleteAdmin = async (id: number): Promise<void> => {
  await api.delete(`/api/Admin/DeleteAdmin/${id}`);
};
